<script setup>
import { ref } from '#imports';

const headerElement = ref();
defineProps({
  isTransparent: { type: Boolean, default: false },
});
</script>

<template>
  <header
    ref="headerElement"
    :class="{
      header: true,
      'header--transparent': isTransparent,
      'header--simple': !isTransparent,
    }"
  >
    <div class="header__container">
      <NuxtLink
        :to="{ name: 'index' }"
        class="header__link"
        exact-active-class="header__link--active"
      >
        <div class="header__logo"></div>
      </NuxtLink>
    </div>
  </header>
</template>

<style lang="postcss" scoped>
.header {
  &--simple {
    transition: var(--default-transition) background;
    border-radius: 0 0 24px 24px;
    background-color: var(--accent-color);
  }

  &--transparent {
    position: absolute;
    z-index: 10;
    top: 0;
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    background: transparent;
  }

  &__logo {
    background-image: url("data:image/svg+xml,%3Csvg width='255' height='33' viewBox='0 0 255 33' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M148.276 28H142.312V9.604L145 12.292H129.208L131.896 9.604V28H125.904V7H148.276V28ZM163.943 7C165.717 7 167.238 7.308 168.507 7.924C169.795 8.52133 170.785 9.37067 171.475 10.472C172.166 11.5547 172.511 12.824 172.511 14.28C172.511 15.7547 172.166 17.0427 171.475 18.144C170.785 19.2267 169.795 20.076 168.507 20.692C167.238 21.2893 165.717 21.588 163.943 21.588H154.871V16.8H163.607C164.503 16.8 165.203 16.576 165.707 16.128C166.211 15.68 166.463 15.064 166.463 14.28C166.463 13.496 166.211 12.8893 165.707 12.46C165.203 12.012 164.503 11.788 163.607 11.788H155.403L158.091 9.016V28H152.099V7H163.943ZM176.835 19.236H191.283V24.024H176.835V19.236ZM197.639 28H191.227L183.331 9.576H185.011L177.115 28H170.731L180.223 7H188.119L197.639 28ZM199.541 7H205.477V24.836L203.825 24.472L215.501 7H223.313V28H217.405V9.828L219.057 10.164L207.157 28H199.541V7ZM208.781 0.587999C209.005 1.18533 209.331 1.63333 209.761 1.932C210.209 2.23067 210.75 2.38 211.385 2.38C212.019 2.38 212.551 2.23067 212.981 1.932C213.41 1.63333 213.746 1.18533 213.989 0.587999H218.665C218.254 2.324 217.414 3.612 216.145 4.452C214.894 5.27333 213.307 5.684 211.385 5.684C209.462 5.684 207.866 5.27333 206.597 4.452C205.346 3.612 204.506 2.324 204.077 0.587999H208.781ZM225.704 22.708H230.352L232.172 22.764H246.648L248.16 22.708H254.348V32.228H248.72V28H231.332V32.228H225.704V22.708ZM250.708 7V26.376H244.716V9.52L247.432 12.208H233.236L235.7 10.22C235.831 11.004 235.915 11.7693 235.952 12.516C235.989 13.2627 236.008 14.056 236.008 14.896C236.008 17.0987 235.812 18.9373 235.42 20.412C235.047 21.8867 234.477 22.9973 233.712 23.744C232.947 24.4907 231.985 24.864 230.828 24.864L228.336 22.82C229.064 21.9427 229.605 20.7573 229.96 19.264C230.315 17.752 230.492 15.8853 230.492 13.664C230.492 11.872 230.343 9.65067 230.044 7H250.708Z' fill='%2374FFAB'/%3E%3Cpath d='M13.74 6.5C16.46 6.5 18.85 6.97 20.91 7.91C22.97 8.83 24.57 10.14 25.71 11.84C26.85 13.54 27.42 15.51 27.42 17.75C27.42 19.99 26.85 21.96 25.71 23.66C24.57 25.36 22.97 26.68 20.91 27.62C18.85 28.54 16.46 29 13.74 29H1.8V6.5H13.74ZM6 22.1H14.34C15.44 22.1 16.38 21.93 17.16 21.59C17.96 21.23 18.57 20.73 18.99 20.09C19.41 19.43 19.62 18.65 19.62 17.75C19.62 16.85 19.41 16.08 18.99 15.44C18.57 14.78 17.96 14.28 17.16 13.94C16.38 13.58 15.44 13.4 14.34 13.4H6L9.48 9.95V25.55L6 22.1ZM43.0287 29.54C40.3087 29.54 37.9187 29.05 35.8587 28.07C33.7987 27.09 32.1987 25.71 31.0587 23.93C29.9187 22.15 29.3487 20.09 29.3487 17.75C29.3487 15.41 29.9187 13.35 31.0587 11.57C32.1987 9.79 33.7987 8.41 35.8587 7.43C37.9187 6.45 40.3087 5.96 43.0287 5.96C45.7487 5.96 48.1387 6.45 50.1987 7.43C52.2587 8.41 53.8587 9.79 54.9987 11.57C56.1387 13.35 56.7087 15.41 56.7087 17.75C56.7087 20.09 56.1387 22.15 54.9987 23.93C53.8587 25.71 52.2587 27.09 50.1987 28.07C48.1387 29.05 45.7487 29.54 43.0287 29.54ZM43.0287 22.64C44.2487 22.64 45.2987 22.45 46.1787 22.07C47.0587 21.67 47.7287 21.11 48.1887 20.39C48.6687 19.65 48.9087 18.77 48.9087 17.75C48.9087 16.73 48.6687 15.86 48.1887 15.14C47.7287 14.4 47.0587 13.84 46.1787 13.46C45.2987 13.06 44.2487 12.86 43.0287 12.86C41.8087 12.86 40.7587 13.06 39.8787 13.46C38.9987 13.84 38.3187 14.4 37.8387 15.14C37.3787 15.86 37.1487 16.73 37.1487 17.75C37.1487 18.77 37.3787 19.65 37.8387 20.39C38.3187 21.11 38.9987 21.67 39.8787 22.07C40.7587 22.45 41.8087 22.64 43.0287 22.64ZM72.2562 14.93L83.6562 29H74.1462L67.4262 20.09H71.3262L64.5462 29H55.1562L66.6462 14.93V19.7L55.7262 6.5H65.4162L71.4762 14.51H67.5762L73.5162 6.5H83.0862L72.2562 19.7V14.93ZM90.3724 19.07H105.702V25.22H90.3724V19.07ZM113.202 29H104.952L97.1824 9.92H99.1624L91.3924 29H83.1424L93.0124 6.5H103.332L113.202 29Z' fill='white'/%3E%3C/svg%3E%0A");
    width: 256px;
    height: 30px;
    background-repeat: no-repeat;
    background-size: contain;
  }

  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: var(--content-max-width);
    height: var(--main-header-height);
    margin: 0 auto;
    padding: 0 60px;
    gap: 10px;

    h2 {
      font-size: 30px;
      font-weight: bold;
      color: #74ffab;
    }
  }

  @media (--tablet-vp) {
    h2 {
      font-size: 18px;
    }
  }
}
</style>
